<template>
  <RouteView />
</template>

<script>
import RouteView from './components/RouteView.vue'
export default {
  name: 'App',
  components: {
    RouteView
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
   height: 100vh;
  width: 100%;
  margin: 0px !important;
}
</style>
